<span
  style="width: max-content"
  itemscope
  itemtype="https://schema.org/BreadcrumbList"
>
  @for (item of $items(); track $index) {
    <a
      [routerLink]="item | url"
      queryParamsHandling="merge"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      >{{ item.label
      }}<meta itemprop="item" content="{{ item | url: 'full' }}" />
      <meta itemprop="name" content="{{ item.label }}" />
      <meta itemprop="position" content="{{ $index + 1 }}"
    /></a>
    @if (!$last) {
      &nbsp;|&nbsp;
    }
  }
</span>
